export default {
  noMatchesFound: 'Medzi zdrojom a cieľom sa nenašlo žiadne prekrytie signálov. Migrácia nie je možná',
};
